"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inlineIcon = void 0;
var _styledComponents = require("styled-components");
var inlineIcon = exports.inlineIcon = (0, _styledComponents.css)(["> svg{height:1em;width:1em;top:0.125em;position:relative;}"]);